// src/data/exercises/L5_07.js

const accountOptions = [
  '現金', '仮払金', '仮受金', '旅費交通費', '支払手数料'];

export const L5_07 = {
  title: '簿記　3級（第214-7回）',
  questions: [
    {
      id: 'q1',
      type: 'JOURNAL_ENTRY',
        content: {

     parts: [
    { "type": "ruby", "text": "従業員", "ruby": "じゅうぎょういん" },
    { "type": "text", "value": "が" },
    { "type": "ruby", "text": "出張", "ruby": "しゅっちょう" },
    { "type": "text", "value": "から" },
    { "type": "ruby", "text": "戻", "ruby": "もど" },
    { "type": "text", "value": "り、" },
    { "type": "ruby", "text": "概算払", "ruby": "がいさんばら" },
    { "type": "text", "value": "いしていた" },
    { "type": "ruby", "text": "出張費", "ruby": "しゅっちょうひ" },
    { "type": "text", "value": "￥100,000を" },
    { "type": "ruby", "text": "精算", "ruby": "せいさん" },
    { "type": "text", "value": "したところ、" },
    { "type": "ruby", "text": "旅費", "ruby": "りょひ" },
    { "type": "text", "value": "は￥94,000との" },
    { "type": "ruby", "text": "報告", "ruby": "ほうこく" },
    { "type": "text", "value": "を" },
    { "type": "ruby", "text": "受", "ruby": "う" },
    { "type": "text", "value": "け、" },
    { "type": "ruby", "text": "残額", "ruby": "ざんがく" },
    { "type": "text", "value": "は" },
    { "type": "ruby", "text": "現金", "ruby": "げんきん" },
    { "type": "text", "value": "で" },
    { "type": "ruby", "text": "受", "ruby": "う" },
    { "type": "text", "value": "け取った。" }
]
      },
      table: {
        options: accountOptions,
      },
      // Đáp án có 1 dòng Nợ và 2 dòng Có
      answer: [
        { debitAccount: '旅費交通費', debitAmount: 94000, creditAccount: '仮払金', creditAmount: 100000 },
        { debitAccount: '現金', debitAmount: 6000, creditAccount: null, creditAmount: null },
              ],
       // Giải thích chi tiết khi trả lời ĐÚNG (có định dạng)
      explanation_correct: {

        parts: [
          { type: 'text', value: '「出張・概算払い」→仮払金を使う\n' },
          { type: 'styled', value: '①「出張費￥100,000を精算」→仮払金の減少（マイナス）貸方（右・Ｃｒ）\n\n', color: 'red', bold: true },
          { type: 'styled', value: '①②旅費は￥94,000→旅費交通費が借方（左・Ｄｒ）\n\n', color: 'red', bold: true },
          { type: 'styled', value: '③残額は現金で受け取った。→100,000-94,000現金が増加（プラス）借方（左・Ｄｒ）', color: 'red', bold: true },
        ]

      },

      // Gợi ý 2 cấp độ khi trả lời SAI
      hints: {
        account: [
          // Gợi ý lần 1, 2
`
「出張・概算払い」→仮払金を使う
①「出張費￥100,000を精算」→仮払金の減少（マイナス）します。

②旅費は￥94,000→旅費交通費が発生（プラス）します。

③残額は現金で受け取った。→100,000-94,000現金が増加（プラス）します。


`,
          // Gợi ý lần 3 (chi tiết hơn, có định dạng)
          {
            parts: [
          { type: 'text', value: '「出張・概算払い」→仮払金を使う\n' },
          { type: 'styled', value: '①「出張費￥100,000を精算」→仮払金の減少（マイナス）貸方（右・Ｃｒ）\n\n', color: 'red', bold: true },
          { type: 'styled', value: '①②旅費は￥94,000→旅費交通費が借方（左・Ｄｒ）\n\n', color: 'red', bold: true },
          { type: 'styled', value: '③残額は現金で受け取った。→100,000-94,000現金が増加（プラス）借方（左・Ｄｒ）', color: 'red', bold: true },
        ]
          }
        ],
       
      },
    },
  ],
};